export class SalaryScale {
    id: number;
    active: boolean;
    category: number;
    jointCommissionCode : number;
    seniority : number;
    value : number;
  }